export default __webpack_public_path__ + "static/media/CuotaYaLogo.16a313f6.webp";